export default "__VITE_ASSET__Bjc8HPQW__"